import { UnitTest } from "../UnitTestClass";
import { SCHEMAS } from "../../constants";

export const validateQCAssignmentSchema = (dataset) => {
  // 1. Check schema
  const qcAssignmentValidations = new UnitTest(dataset);
  const checkSchema = qcAssignmentValidations.checkSchema(
    SCHEMAS.qcAssignmentSchema
  );
  return { checkSchema };
};

export const validateQCAssignmentIntra = (dataset) => {
  const qcAssignmentValidations = new UnitTest(dataset);
  // 1. Duplicates Test on QuotaComponent
  const duplicatesTestQuotaComponent = qcAssignmentValidations.checkDuplicates([
    "QuotaComponent",
  ]);
  const duplicatesTestbattleCardName = qcAssignmentValidations.checkDuplicates([
    "BattlecardName",
  ]);

  return { duplicatesTestQuotaComponent, duplicatesTestbattleCardName };
};
